import { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { LIST_SEARCH_PARAM_KEY } from '@/utils/const';
import './index.less';

interface IProps {
  tabs: {
    label: string;
    value: number;
  }[];
  className?: string;
  tabItemWidth?: string; // 添加 tabItemWidth 属性
  onChange?: (value: number) => void;
}

export default (props: IProps) => {
  const { pathname } = useLocation();

  const history = useHistory();

  const { tabs, className, tabItemWidth, onChange } = props;
  const [active, setActive] = useState(() => tabs?.[0]?.value || '');

  const handleChange = (value: number) => {
    if (value === active) return;

    history.push({
      pathname,
      search: `${LIST_SEARCH_PARAM_KEY}=${''}`,
    });

    setActive(value);
    onChange?.(value);
  };

  return (
    <div className={`switch-tab ${className}`}>
      {tabs?.map((item) => {
        return (
          <span
            key={item.value}
            style={{
              width: tabItemWidth || '96px', // 默认宽度为 96px
            }}
            className={`tab-item ${active === item.value ? 'tab-item-active' : ''}`}
            onClick={() => handleChange(item.value)}
          >
            {item.label}
          </span>
        );
      })}
    </div>
  );
};
